import { Component, OnInit, HostListener, Optional, Inject } from '@angular/core';
import { QuickQuoteService } from '../../services/quickquote-service.service';
import { switchMap } from 'rxjs/operators';
import { FormBuilder, FormGroup, AbstractControl } from '@angular/forms';
import { PershingTranslationService, IAppDataStore, IAuthorizationService } from '@pershing/pershing-core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import moment_ from 'moment-timezone';    const moment = moment_;
import { debounceTime } from 'rxjs/operators';
import { PershingDecimalFormatPipe } from '@pershing/pershing-core';

@Component({
    selector: 'mod-quickquote',
    templateUrl: './quick-quote.component.html',
    styleUrls: ['./quick-quote.component.css']
})
export class QuickQuoteComponent implements OnInit {
    filteredSymbols: any[] = [];
    quickQuoteForm: FormGroup;
    htmlContent: any;
    showTT: boolean = false;
    hasAgreed: boolean = false;
    showLink: boolean = false;
    showRealTimeToggle: boolean = false;
    showFullQuote: boolean = false;
    fullQuoteUrl: string;
    symbol: string;
    isAdvisor: boolean = false;
    frompage: string;
    queryParam: Params;
    delay: any;
    isRealTimePref: boolean = false;
    // Specifically for mobile as user may select realtime but haven't sign agreement and as such, it the selection would need to be reverted.
    displayRealtime: boolean = false;
    realtimeToggleFocusout: boolean = false;
    invalidSymbol: boolean = false;
    public header: string = '';
    cardDisplay: boolean = true;
    showQuickQuote: boolean = true;
    userHasSelectedASymbol: boolean = false;
    sysDate: Date = new Date();
    quickQuotePlaceHolder: string = 'QUICK_QUOTE_PLACEHOLDER';
    deviceType: string = 'desktop';
   

    constructor(
        public fb: FormBuilder,
        public QuickQuoteService: QuickQuoteService,
        private translationService: PershingTranslationService,
        private appStore: IAppDataStore,
        private authService: IAuthorizationService,
        public pershingDecimalFormatingPipe: PershingDecimalFormatPipe,
        @Optional() private route: ActivatedRoute,
        @Optional() private router: Router,
        @Optional() @Inject('AppSettings') appSettings: any
    ) {
        this.header = 'QUICK_QUOTE';
        this.translationService.addTranslationFolder('@pershing/nxi-ng-mod', 'node_modules/@pershing/nxi-ng-mod/lib');
        this.showFullQuote = this.authService.isEntitled('MOD_QUOTES_NEWS');
        this.showRealTimeToggle = (this.authService.isEntitled('REAL_TIME_EQUITY_QUOTES') && !appSettings.isAdvisor);
        this.isAdvisor = appSettings.isAdvisor;
         if (appSettings.isLoggedIn) {
            this.showQuickQuote = !(this.authService.isEntitled('EDELIVERY_ONLY'));
        this.setQuickQuotePlaceHolder(appSettings);
        
        }
        if (appSettings.deviceType) {
            this.deviceType = appSettings.deviceType;
        }
        if (appSettings.isAdvisor) {
            this.delay = 2000;
        } else {
            this.delay = 100;
        }
    }
    setQuickQuotePlaceHolder(appSettings) {
        this.quickQuotePlaceHolder = appSettings.deviceType && appSettings.deviceType === 'mobile' ? appSettings.ibdConfigMap.IBD === 'C01'? 
        'QUICK_QUOTE_PLACEHOLDER':'QUICK_QUOTE_PLACEHOLDER_POSTLOGIN' : 'QUICK_QUOTE_PLACEHOLDER';
    }
    ngOnInit() {
        if (this.router) {
            this.frompage = this.router.url.split('?')[0];
        }
        if (this.route) {
            this.route.queryParams.subscribe(
                (param) => {
                    this.queryParam = param;
                }
            );
        }

        this.quickQuoteForm = this.fb.group({
            symbolInput: null
        });
        if (this.showRealTimeToggle) {
            this.QuickQuoteService.getUserPreference().subscribe(
                data => {
                    this.isRealTimePref = data;
                    this.displayRealtime = this.isRealTimePref;
                }
            );
        }
        this.quickQuoteForm
            .get('symbolInput')
            .valueChanges
            .pipe(debounceTime(this.delay),
                switchMap(
                    value => {
                        this.invalidSymbol = false;
                        return this.QuickQuoteService.getModSymbolLookupResponse(value);
                    }
                )
            )
            .subscribe(symbols => {
                if (this.showTT && this.symbol === this.symbolInput.value) {
                    this.filteredSymbols = [];
                    return;
                }
                if (symbols.length === 1) {
                    this.showQuoteToolTip(symbols[0].Symbol); // Show the details if the full symbol typed already
                } else {
                    this.filteredSymbols = symbols;
                    if (this.filteredSymbols == null || this.filteredSymbols.length === 0) {
                        this.invalidSymbol = true;
                    }
                }
            });
    }

    handleClose() {
        // User may try and select a symbol or not so handle accordingly.
        if (this.userHasSelectedASymbol) {
            // Reset selection flag.
            this.userHasSelectedASymbol = false;
        } else {
            // Clear the input b/c user did not select any option.
            this.quickQuoteForm.setValue({ symbolInput: '' });
        }
    }

    handleOpen() {
        // Ensure to hide the quote content if user tries to update symbol input
        this.showTT = false;
    }

    clickClose() {
        this.quickQuoteForm.setValue({ symbolInput: '' });
        this.showTT = false;
    }

    showQuoteToolTip(symbol: string) {
        // Reset visibility of agreement div just in case it was open previously.
        this.showLink = false;
        this.userHasSelectedASymbol = true;
        this.htmlContent = null;
        this.filteredSymbols = [];
        if (this.showRealTimeToggle && this.isRealTimePref) {
            this.getRealTimeQuote(symbol);
        } else {
            this.getDelayedQuote(symbol);
        }
    }
    getRealTimeQuote(symbol: string) {
        this.QuickQuoteService.getRealTimeKey(symbol).subscribe(
            (key) => {
                if (key && key.length > 0) {
                    this.QuickQuoteService.getModSymbolDataRT(key[0])
                        .subscribe((res: any) => {
                            if (res && res[0]) {
                                this.processQuoteData(res);
                                this.QuickQuoteService.setUserPreference(true).toPromise();
                                this.isRealTimePref = true;
                                this.displayRealtime = this.isRealTimePref;
                            } else {
                                this.getDelayedQuote(symbol); // If real time quote is failing, go for delayed quote
                            }
                        });
                } else {
                    this.getDelayedQuote(symbol);
                }
            }
        );
    }
    getDelayedQuote(symbol: string) {
        this.QuickQuoteService.getModSymbolData(symbol)
            .subscribe((res: any) => {
                if (res && res[0]) {
                    this.processQuoteData(res);
                } else {
                    this.invalidSymbol = true;
                }
            });
        if (this.isRealTimePref) {
            this.QuickQuoteService.setUserPreference(false).toPromise();
            this.isRealTimePref = false;
            this.displayRealtime = this.isRealTimePref;
        }
    }
    processQuoteData(res: any) {
        let data = res[0];
        if (data.Symbol) {
            this.htmlContent = this.updateAsOfDate(data);
            this.symbol = data.Symbol;
            if (data.IssueType === 'MF') {
                this.fullQuoteUrl = '/nxi/research/quotenews/mutualfunds/mfsummary';
            } else if (data.IssueType === 'ETF') {
                this.fullQuoteUrl = '/nxi/research/quotenews/etf/etfsummary';
            } else {
                this.fullQuoteUrl = '/nxi/research/quotenews/stocks/summary';
            }
            setTimeout(() => {
                this.showTT = true;
            }, 100);
        }
    }
    updateAsOfDate(data: any) {
        if (data.LastPriceTime && !!data.LastPriceTime) {
            let asOfDateArray = (data.LastPriceTime).split(' ');
            if (this.isSysAndModDateSame(data.LastPriceTime)) {
                data.LastPriceTime = asOfDateArray[1] + ' ' + asOfDateArray[2] + ' ' + asOfDateArray[3];
            } else {
                data.LastPriceTime = asOfDateArray[1] + ' ' + asOfDateArray[2] + ' ' + asOfDateArray[3] + ' ' + asOfDateArray[0];
            }
        }
        return data;
    }
    isSysAndModDateSame(modLastPriceTime: string) {
        let dateFromModArray = (modLastPriceTime).split(' ');
        let dateFromModInMsec = Date.parse(dateFromModArray[0] + ' ' + dateFromModArray[1] + ' ' + dateFromModArray[2]);
        let modDate = new Date(dateFromModInMsec);
        let sysDate = this.sysDate;
        // If either behind one another then it's not the same.
        return !(moment(sysDate).isAfter(modDate, 'day') || moment(modDate).isAfter(sysDate, 'day'));
    }
    toggleRealTime() {
        if (this.showRealTimeToggle && !this.isRealTimePref && this.symbol) {
            this.QuickQuoteService.getAgreementDetails().subscribe(data => {
                if (data === 0) {
                    this.hasAgreed = true;
                    this.getRealTimeQuote(this.symbol);
                } else if (data === 2) {
                    this.isAdvisor = true;  // invalid scenario as realtime toggle wont be shown to advisor
                } else {
                    this.hasAgreed = false;
                    this.showLink = true;  // user not agreed to exchange agreement,
                }
            });
        } else if (this.isRealTimePref && this.symbol) {
            this.getDelayedQuote(this.symbol);
        }
    }
    redirectToFullQuote() {
        this.redirect(this.getParamWithSymbol(), this.fullQuoteUrl);
        this.quickQuoteForm.setValue({ symbolInput: '' });
        this.showTT = false;
    }
    redirectToExchangeAgreement() {
        this.appStore.put('EXCHANGE_AGREE_LASTPAGE', this.router.url.split('?')[0]);
        this.redirect(this.getParamWithSymbol(), '/nxi/exchangeagreementoverview');
        this.cardDisplay = false;
    }
    getParamWithSymbol(): any {
        let param = this.queryParam ? JSON.parse(JSON.stringify(this.queryParam)) : {};
        param.Symbol = this.symbol;
        return param;
    }
    redirect(param: any, url: string) {
        document.dispatchEvent(new CustomEvent('portal.gotoview', {
            detail: {
                'gotoParams': param,
                'gotoPage': url
            }
        }));

    }
    get symbolInput(): AbstractControl {
        return this.quickQuoteForm.get('symbolInput');
    }
    @HostListener('document:click', ['$event']) onClick(event: any) {
        let element = event.target;
        if (this.realtimeToggleFocusout) {
            // ignorable click as user tries to toggle quote reference within the quote tooltip.
            this.displayRealtime = this.isRealTimePref;
            this.realtimeToggleFocusout = false;
            return;
        }
        while (element) {
            // ignorable click if user click anywhere within the popup/tooltip.
            if (element.id === 'quick-quote-popup' || element.id === 'quick-quote-popup-form') {
                return;
            }
            element = element.parentElement;
        }
        this.htmlContent = '';
        // Clear the symbol field if:
        // case 1:  User has selected a symbol and content shown, now user clicks somewhere.
        // case 2:  symbol list being fetched - this is handled as off focused case 2 below.
        if (this.showTT) {
            this.quickQuoteForm.setValue({ symbolInput: '' });
        }
        this.showTT = false;
        this.cardDisplay = true;
    }
    // Clear the symbol field if:
    // case 1.  quick-quote-popup is off focused.
    // case 2.  quick-quote-popup-form is off focused and quote content not show.
    @HostListener('focusout', ['$event']) onBlur(event: any) {
        let element = event.target;
        while (element) {
            if (element.id.indexOf('mat-select-display') >= 0 && this.showTT) {
                this.realtimeToggleFocusout = true;
                return;
            } else if (element.id === 'quick-quote-popup' && !this.showLink) {
                this.quickQuoteForm.setValue({ symbolInput: '' });
                this.showTT = false;
            } else if (element.id === 'quick-quote-popup-form' && !this.showTT) {
                this.quickQuoteForm.setValue({ symbolInput: '' });
            }
            element = element.parentElement;
        }
    }
}
